'use client';
import { styled } from 'styled-components';
import ContentText from './ContentText';
import { ReactNode } from 'react';

type Props = {
  size?: 'small' | 'large';
  label: string | ReactNode;
  theme?: 'red' | 'white' | 'gold' | 'link' | 'icon' | 'icon-white';
  onClick?: () => void;
  className?: string;
  $disable?: boolean;
  $submit?: boolean;
  $starticon?: React.ReactNode;
  $endicon?: React.ReactNode;
  title?: string;
  id?: string;
  wrap?: 'wrap' | 'nowrap';
  $smallWidth?: boolean;
};

const Button: React.FC<Props> = (props: Props) => {
  const textType =
    props.theme === 'link' && props.size === 'small'
      ? 'article-m'
      : props.theme === 'red' || props.theme === 'white' || !props.theme
      ? props.size === 'small'
        ? 'label-l'
        : 'button'
      : 'article-l';

  return (
    <ButtonWrapper
      id={props.id}
      type={props.$submit ? 'submit' : 'button'}
      {...props}
      onClick={props.$disable ? undefined : props.onClick}
      title={props.title}
      $disable={props.$disable}
      theme={props.theme}
    >
      {props.$starticon && props.$starticon}
      <ContentText className="buttonlabel" type={textType}>
        {props.label}
      </ContentText>
      {props.$endicon && props.$endicon}
    </ButtonWrapper>
  );
};

const ButtonWrapper = styled.button<Props>`
  padding: ${(props) => (props.size === 'small' ? '8px 16px' : '16px 24px')};
  transition: 0.1s;
  ${(props) => {
    if (props.$disable) {
      return `
      border-radius: 4px;
        background: var(--border-disabled);
        color: white;
        border: none !important;
        cursor: not-allowed;
        svg{
            flex-shrink: 0;
        }
        &:hover {
          background: var(--border-disabled) !important;
          color: white !important;
          border: none !important;
          box-shadow: 0 0 0 1px transparent !important;
          cursor: not-allowed !important;
          
        }
      `;
    }
  }}
  ${(props) => {
    switch (props.theme) {
      case 'gold':
        return `
          border-radius: 4px;
          background-color: white;
          white-space: nowrap;
          border: 1px solid var(--button-gold, #ccb477);
          color: var(--button-gold, #ccb477);
          
          &:hover {
            cursor: pointer;
          }
        `;
      case 'white':
        return `
          border-radius: 4px;
          background-color: white;
          white-space: nowrap;
          border: 1px solid var(--base-black); 
          color: var(--base-black); 
          max-width: 22.8125rem;
          width:100%;
          svg{
            flex-shrink: 0;
          }
          &:hover {
            color: var(--red-700-button-accent, #b91c1c);
            border: 1px solid var(--red-700-button-accent, #b91c1c);
            box-shadow: 0 0 0 1px var(--red-700-button-accent, #b91c1c);
            cursor: pointer;
          }
        `;
      case 'link':
        return `
          .buttonlabel {
            color: var(--base-black); 
            border-bottom:1px solid black;
            white-space: ${props.wrap === 'wrap' ? 'wrap' : 'nowrap'};
            word-break: ${props.wrap === 'wrap' ? 'break-word' : 'normal'};
              &:hover {
                color: var(--node-todo);
                border-bottom: 1px solid var(--node-todo);
                cursor: pointer;
              }
          }
          text-align: ${props.wrap === 'wrap' ? 'left' : ''};
          border: 0;
          padding: 0;
          background-color: rgba(0,0,0,0);
        `;
      case 'icon':
        return `
          border: 0;
          padding: 0;
          white-space: nowrap;
          cursor: pointer;
          background-color: rgba(0,0,0,0); 
          svg{
            flex-shrink: 0;
          }
          .buttonlabel {
            display: flex;
          }
        `;
      case 'icon-white':
        return `
            border: 0;
            padding:0;
            color: "#fff";
            background-color: rgba(0,0,0,0); 
            svg {
              color: #fff; 
              flex-shrink: 0;
            }
            .buttonlabel {
              display: flex;
              flex-shrink: 0;
            }
          `;
      default:
        return `
          border-radius: 4px;
          background-color: var(--color-red, #c12827);
          white-space: nowrap;
          cursor: pointer;
          border: 0;
          color: white;
          max-width: 22.8125rem;
          width:100%;
          svg{
            flex-shrink: 0;
          }
          &:hover {
            background-color: var(--hover-700-button-accent, #CE6060);
          }
        `;
    }
  }}

  ${(props) => {
    if (props.theme != 'link') {
      switch (props.size) {
        case 'large':
          return `
            padding: 16px 24px 16px 24px;
            border-radius: 4px;
        `;
        case 'small': {
          return `
            padding: 8px 16px 8px 16px;
            border-radius: 4px;
        `;
        }
      }
    }
  }}
  ${(props) => {
    if (props.$disable) {
      if (props.theme != 'link') {
        return `
        background: var(--border-disabled);
        border: none;
        color: white;
        `;
      }
    } else {
      return `
        &:hover {
        cursor: pointer;
        }  
      `;
    }
  }}

  ${(props) => {
    if (props.$starticon || props.$endicon) {
      return `
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 4px;
      `;
    }
  }}
  
  ${(props) =>
    props.$smallWidth &&
    `
    width: auto;
    max-width: none;
  `}
`;
export default Button;
